const getters = {
  sysMessage: state => state.app.sysMessage,
  sysReadMessage: state => state.app.sysReadMessage,
  jzb_enable: state => state.jzb.jzb_enable,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  platformOrderMessage: state => state.platform.noArrivedOrder,
  orderTotal: state => state.permission.order_total,
  pendingOrderFlag: state => state.app.pending_order_flag,
  pendingAsOrderFlag: state => state.app.pending_as_order_flag
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js